// mantine
import {
    Combobox,
    CloseButton,
    Input,
    InputBase,
    useCombobox
} from '@mantine/core';
// components
import ActorOption from '@/modules/Personas/components/ActorCombobox/components/ActorOption';
// utils
import { IActorCore } from '@/modules/Personas/components/ActorCombobox/ActorCombobox.types';

interface ActorComboboxProps<T extends IActorCore> {
    className?: string;
    label?: string;
    actors: T[];
    placeholder?: string;
    value?: string;
    onChange: (actorId?: string) => void;
}

const ActorCombobox = <T extends IActorCore>({
    className,
    actors,
    label,
    placeholder = 'Select Actor',
    value,
    onChange
}: ActorComboboxProps<T>) => {
    const combobox = useCombobox({
        onDropdownClose: () => {
            combobox.resetSelectedOption();
        }
    });

    const options = actors.map((actor) => (
        <Combobox.Option key={actor.id} value={actor.id}>
            <ActorOption actor={actor} />
        </Combobox.Option>
    ));

    const actor = actors.find((a) => a.id === value);

    const handleClear = () => {
        combobox.resetSelectedOption();
        onChange();
    };

    return (
        <div className={className}>
            <Combobox
                store={combobox}
                withinPortal={false}
                onOptionSubmit={(actorId: string) => {
                    combobox.closeDropdown();
                    onChange(actorId);
                }}
            >
                <Combobox.Target>
                    <InputBase
                        multiline
                        pointer
                        component="button"
                        label={label}
                        rightSection={
                            value ? (
                                <CloseButton size="sm" onClick={handleClear} />
                            ) : (
                                <Combobox.Chevron />
                            )
                        }
                        rightSectionPointerEvents={value ? 'auto' : 'none'}
                        size="xs"
                        type="button"
                        onClick={() => {
                            combobox.toggleDropdown();
                        }}
                    >
                        {actor ? (
                            <ActorOption actor={actor} />
                        ) : (
                            <Input.Placeholder>{placeholder}</Input.Placeholder>
                        )}
                    </InputBase>
                </Combobox.Target>

                <Combobox.Dropdown>
                    <Combobox.Options className="overflow-auto" mah={250}>
                        {options}
                    </Combobox.Options>
                </Combobox.Dropdown>
            </Combobox>
        </div>
    );
};

export default ActorCombobox;
